import { createSlice } from '@reduxjs/toolkit';
import { USER_PROFILE_INITIAL_STATE } from '@/redux/modal/UserProfile/userProfile.constants';
import {
  openAuthTokensReducer,
  openDetailsReducer,
} from '@/redux/modal/UserProfile/userProfile.reducers';

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: USER_PROFILE_INITIAL_STATE,
  reducers: {
    openDetails: openDetailsReducer,
    openAuthTokens: openAuthTokensReducer,
  },
});

export const { openDetails, openAuthTokens } = userProfileSlice.actions;

export default userProfileSlice.reducer;
